import { Component, ElementRef, OnInit, ViewChild, computed } from '@angular/core';
import { Logger } from '@bannerflow/sentinel-logger';
import { UIDialogComponent, UINewThemeService } from '@bannerflow/ui';
import QRCodeStyling from 'qr-code-styling';

@Component({
    selector: 'qr-code-modal',
    templateUrl: './qr-code-modal.component.html',
    styleUrls: ['./qr-code-modal.component.scss', './qr-code-modal.new.component.scss'],
    standalone: false
})
export class QRCodeModalComponent implements OnInit {
    @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLElement>;

    public targetMessage: string;
    private logger = new Logger('QRCodeModalComponent');

    constructor(
        private dialog: UIDialogComponent,
        private uiNewThemeService: UINewThemeService
    ) {}
    isNewUI = computed(() => this.uiNewThemeService.isNewThemeEnabled());

    ngOnInit(): void {
        const { link, message } = this.dialog.config.data;
        if (!link) {
            throw new Error('No temporary link found');
        }
        this.targetMessage = message;

        this.generateQRCode(link, this.canvas.nativeElement);
    }

    close(): void {
        this.dialog.dialogRef.close();
    }

    private generateQRCode(data: string, element: HTMLElement): void {
        if (!QRCodeStyling) {
            this.logger.warn('Generating QR code canceled, because the library has not been found');
            return;
        }

        const qrCode = new QRCodeStyling({
            width: this.isNewUI() ? 208 : 186,
            height: this.isNewUI() ? 208 : 186,
            data,
            image: 'assets/logo.png',
            dotsOptions: {
                type: 'square',
                color: '#000000'
            },
            cornersSquareOptions: {
                type: 'square',
                color: '#000000'
            },
            qrOptions: {
                typeNumber: 0,
                mode: 'Byte',
                errorCorrectionLevel: 'Q'
            },
            imageOptions: {
                imageSize: 0.4,
                margin: 6
            }
        });

        qrCode.append(element);
    }
}
